import React from 'react';
import { AlertCircleIcon, CheckCircleIcon } from './Icons';
import './AlertDialog.css';

const AlertDialog = ({ isOpen, title, message, buttonText = 'OK', onClose, type = 'info' }) => {
  if (!isOpen) return null;

  const IconComponent = type === 'success' ? CheckCircleIcon : AlertCircleIcon;

  return (
    <div className="alert-dialog-overlay" onClick={onClose}>
      <div className="alert-dialog" onClick={(e) => e.stopPropagation()}>
        <div className="alert-dialog__header">
          <div className="alert-dialog__icon-wrapper">
            <IconComponent className={`alert-dialog__icon alert-dialog__icon--${type}`} size={24} />
          </div>
          <h3 className="alert-dialog__title">{title}</h3>
        </div>
        <div className="alert-dialog__content">
          <p className="alert-dialog__message">{message}</p>
        </div>
        <div className="alert-dialog__actions">
          <button
            onClick={onClose}
            className={`alert-dialog__btn alert-dialog__btn--${type}`}
          >
            {buttonText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AlertDialog;










